import firebaseApp from '../../../../services/firebaseService';
import { BasicBaseHelper, IBasicBaseClass } from '../../base';

export interface IPumpingStationFlowmeterMake extends IBasicBaseClass {
    name : string;

    isActive : boolean;
}

export default class PumpingStationFlowmeterMakeHelper extends BasicBaseHelper {
    public static readonly COLLECTION_NAME = 'pumping_station_flowmeter_make';

    private static converter : firebase.firestore.FirestoreDataConverter<IPumpingStationFlowmeterMake> = {
        fromFirestore: (snapshot) => {
            return PumpingStationFlowmeterMakeHelper.fromFirestoreDocument(snapshot);
        },
        toFirestore: (data : IPumpingStationFlowmeterMake) : firebase.firestore.DocumentData => {
            return PumpingStationFlowmeterMakeHelper.toFirestoreDocument(data);
        },
    };

    public static fromFirestoreDocument(snapshot : firebase.firestore.DocumentSnapshot) : IPumpingStationFlowmeterMake {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!snapshot.exists || !result || !data) throw new Error(`Document does not exist! ${snapshot.id}`);
        return {
            ...data as IPumpingStationFlowmeterMake,
            ...result,
        };
    }

    public static toFirestoreDocument(data : IPumpingStationFlowmeterMake) {
        const result = super.toFirestore(data);
        const { id: _id, ...rest } = data;

        return {
            ...rest,
            ...result,
        };
    }

    public static doc(id ?: string) {
        if (!id) {
            return firebaseApp.firestore().collection(PumpingStationFlowmeterMakeHelper.COLLECTION_NAME).withConverter(PumpingStationFlowmeterMakeHelper.converter).doc();
        }

        return firebaseApp.firestore().collection(PumpingStationFlowmeterMakeHelper.COLLECTION_NAME).withConverter(PumpingStationFlowmeterMakeHelper.converter).doc(id);
    }

    public static save(company : IPumpingStationFlowmeterMake) {
        return PumpingStationFlowmeterMakeHelper.doc(company.id).set(company, {
            merge: true,
        });
    }
    
    public static collection() {
        return firebaseApp
            .firestore()
            .collection(PumpingStationFlowmeterMakeHelper.COLLECTION_NAME)
            .withConverter(PumpingStationFlowmeterMakeHelper.converter);
    }
}